module.exports = __webpack_public_path__ + "img/2015-02_bloomberg_a.a6325f0c.png";